<template>
  <div class="main-layout">
    <div class="left-layout">
      <div class="logo-layout">
        <v-img
            class="logo-image"
            src="@/assets/images/incar_mortgage_260417.png" width="150" alt=""
            @click="navigatePage('/main')"
        />
      </div>
      <div class="menu-layout">
        <v-row>
          <v-col
              class="menu-list-layout"
              v-for="(list, index) in menuTitleList" :key="index"
              @mouseover="showMenu(index)" @mouseleave="hideMenu"
          >
            <span class="menu-title" :class="{'hover': list.path !== ''}" @click="navigatePage(list.path)">{{ list.name }}</span>
            <v-list
                v-if="activeMenuIndex === index"
                class="sub-menu-layout"
                :class="{ 'no-sub-menu': list.subMenuList.length === 0 }"
            >
              <v-list-item
                  class="sub-menu-list"
                  v-for="(sub_menu, sub_index) in list.subMenuList" :key="sub_index"
                  @click="navigatePage(sub_menu.path)"
              >
                <span class="sub-menu-title">{{ sub_menu.name }}</span>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="right-layout">
      <span class="user-name">{{ userData.memberNm }}님,</span>
      <div class="button-layout">
        <span class="my-page-button" @click="navigatePage('/mypage')">내정보</span>
        <v-divider vertical></v-divider>
        <span class="logout-button" @click="logout">로그아웃</span>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {mapGetters} from "vuex";
import store from "@/store";

export default {
  name: "MenuBar",
  data() {
    return {
      menuTitleList: [
        {
          name: "회원", path: "",
          subMenuList: [
            { name: "회원관리", path: "/member/manage", role: "ADMIN" }
          ]
        },
        {
          name: "대출실적", path: "",
          subMenuList: [
            { name: "실적업로드", path: "/loan/perform/upload", role: "ADMIN" },
            { name: "실적통계", path: "/loan/statics", role: "ADMIN" },
            { name: "전체실적", path: "/loan/perform/total", role: "ADMIN" },
            { name: "팀별실적", path: "/loan/perform/team", role: "MANAGER" },
            { name: "개인실적", path: "/loan/perform/mine", role: "" },
            { name: "수수료계산기", path: "/loan/commission", role: "" }
          ]
        },
        {
          name: "게시판", path: "/board",
          subMenuList: [
            { name: "게시판관리", path: "/board/manage", role: "ADMIN" }
          ]
        },
        {
          name: "교육영상", path: "",
          subMenuList: [
            { name: "영상 목록", path: "/lecture", role: "" },
            { name: "교육영상 관리", path: "/lecture/manage", role: "ADMIN" },
            { name: "카테고리 관리", path: "/lecture/category", role: "ADMIN" }
          ]
        },
        // 추가 반영 예정
        {
          name: "증명서", path: "/certificate",
          subMenuList: []
        },
        {
          name: "론앤비즈", path: "/loanAndBiz",
          subMenuList: []
        },
        {
          name: "명세서", path: "",
          subMenuList: [
            { name: "지급 명세서 관리", path: "/payment/manage", role: "ADMIN"},
            { name: "지급 명세서", path: "/payment", role: "USER" }
          ]
        },
        {
          name: "기타", path: "",
          subMenuList: [
            { name: "서비스 로그", path: "/etc/log", role: "ADMIN" }
          ]
        }
      ],
      activeMenuIndex: null,
      maxItemLength: -1
    }
  },
  created() {
    this.setRoleMenuList();
  },
  computed: {
    ...mapGetters("login", {
      userData: "userData",
      memberRole: "memberRole"
    }),
  },
  methods: {
    async logout() {
      await store.dispatch("login/logout", this.userData.id);
    },
    setRoleMenuList() {
      this.menuTitleList = this.menuTitleList.map(menu => {
        let filteredSubMenu = [];

        filteredSubMenu = menu.subMenuList.filter(subMenu => {
          if (this.memberRole === "ADMIN") {
            return subMenu.role !== "USER";
          }

          if (this.memberRole === "MANAGER") {
            return subMenu.role !== "ADMIN";
          }

          if (this.memberRole === "USER") {
            return subMenu.role === "USER";
          }

          return false;
        });

        return {
          ...menu,
          subMenuList: filteredSubMenu
        };
      }).filter(menu => menu.subMenuList.length > 0 || (menu.path !== "" && menu.subMenuList.length === 0));
    },
    showMenu(index) {
      this.activeMenuIndex = index;
    },
    hideMenu() {
      this.activeMenuIndex = null;
    },
    navigatePage(path) {
      if (_.isEmpty(path)) {
        return false;
      } else if (path === "/loanAndBiz") {
        this.showAlert({message: "추후 업데이트 예정입니다"});
      } else {
        const routePath = path;
        if (this.$route.path !== routePath) {
          this.$router.push(routePath);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-layout {
  width: 100vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left-layout {
    display: flex;
    justify-content: center;
    align-items: center;
    .logo-layout {
      margin-right: 100px;
      .logo-image {
        cursor: pointer;
      }
    }
    .menu-layout {
      width: 100%;
      text-align: center;
      .menu-list-layout {
        padding: 20px 0;
        margin: 0;
        width: min(9.5vw, 180px);
        .menu-title.hover:hover {
          cursor: pointer;
        }
        .menu-title {
          font-size: min(1.4vw, 20px);
          font-weight: bold;
          color: #222;
        }
        .sub-menu-layout {
          position: absolute;
          padding: 0;
          top: 70px;
          border: 1px solid #c0c0c0;
          .sub-menu-list {
            width: min(9.5vw, 180px);
            justify-content: center;
            border-bottom: 1px solid #c0c0c0;
            .sub-menu-title {
              font-size: min(1.1vw, 15px);
            }
            .sub-menu-title:hover {
              cursor: pointer;
            }
          }
        }
        .sub-menu-layout.no-sub-menu {
          border: none;
        }
      }
    }
  }
  .right-layout {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: min(1.4vw, 16px);
      font-weight: bold;
    }
    .user-name {
      margin-right: 10px;
    }
    .button-layout {
      display: flex;
      .my-page-button,
      .logout-button {
        color: #1772C7;
        white-space: nowrap;
        padding: 0 5px;
      }
      .my-page-button:hover,
      .logout-button:hover {
        cursor: pointer;
        text-shadow: 0 1px 1px #1772C7;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .menu-layout {
    display: none;
  }

  .left-layout {
    .logo-layout {
      margin-right: 0;
    }
  }

  .right-layout {
    display: none;
    .user-name,
    .my-page-button,
    .logout-button {
      display: none;
    }
  }
}
</style>